import { render, staticRenderFns } from "./SelectCustom.vue?vue&type=template&id=395312be&"
import script from "./SelectCustom.vue?vue&type=script&lang=js&"
export * from "./SelectCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports